import { useQuery } from '@tanstack/react-query';
import { adminFetch } from '@/lib/apiClient';
import type { RevenuePeriod } from '../components/RevenueBarChart';
import type { DashboardWidgetResponse } from '../types/dashboardWidget';

export const dashboardWidgetQueryKey = (period: RevenuePeriod) =>
  ['admin', 'dashboard-widget', period] as const;

const fetchDashboardWidget = async (
  period: RevenuePeriod,
): Promise<DashboardWidgetResponse> => {
  const url = `/admin/v1/dashboard?period=${encodeURIComponent(period)}`;
  const res = await adminFetch(url);
  if (!res.ok) throw new Error(`dashboard fetch failed: ${res.status}`);
  const envelope = (await res.json()) as { data?: DashboardWidgetResponse };
  return envelope.data ?? {};
};

export const useDashboardWidgetQuery = (period: RevenuePeriod) =>
  useQuery<DashboardWidgetResponse>({
    queryKey: dashboardWidgetQueryKey(period),
    queryFn: () => fetchDashboardWidget(period),
    staleTime: 60_000,
  });
